/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProjectDistributionResponseDto } from '../../models/project-distribution-response-dto';

export interface AdminInsightsControllerGetProjectDistributionV1$Params {
}

export function adminInsightsControllerGetProjectDistributionV1(http: HttpClient, rootUrl: string, params?: AdminInsightsControllerGetProjectDistributionV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ProjectDistributionResponseDto>> {
  const rb = new RequestBuilder(rootUrl, adminInsightsControllerGetProjectDistributionV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProjectDistributionResponseDto>;
    })
  );
}

adminInsightsControllerGetProjectDistributionV1.PATH = '/v1/admin/insights/project-distribution';
